import gtagEventEmitter from "./gtagEventEmitter";

const handleZendeskWidgetPress = () => {
  gtagEventEmitter({
    action: "Opened_Messenger",
    category: "Intercom_Messenger",
    label: window?.location?.href,
  });
};

export default handleZendeskWidgetPress;
